import { AfterViewChecked, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ellipsis',
  standalone: true,
  imports: [ NgbTooltip ],
  templateUrl: './ellipsis.component.html',
  styleUrls: [ './ellipsis.component.scss' ]
})
export class EllipsisComponent implements AfterViewChecked {
  @Input() lines: number = 2;
  @ViewChild('contentEl', { static: true }) contentEl: ElementRef<HTMLElement>;

  isTruncated = false;
  tooltipText = '';

  ngAfterViewChecked() {
    const el = this.contentEl.nativeElement;
    const truncated = el.scrollHeight > el.clientHeight + 1;
    if (truncated !== this.isTruncated) {
      this.isTruncated = truncated;
      this.tooltipText = truncated ? this.getVisibleText(el) : '';
    }
  }

  private getVisibleText(el: HTMLElement): string {
    let text = '';
    el.childNodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE) {
        text += node.textContent;
      } else if (node instanceof HTMLElement) {
        if (!node.classList.contains('material-symbols-outlined')) {
          text += this.getVisibleText(node);
        }
      }
    });
    return text.trim();
  }
}

